module.exports = {
  "layout": [
    {
      "w": 100,
      "rows": [
        {
          "h": 50,
          "cols": [
            {
              "w": 50,
              "guid": "w_prepareTransactionSuccessTrends"
            },
            {
              "w": 50,
              "guid": "w_alertbox"
            }
          ]
        },
        {
          "h": 50,
          "cols": [
            {
              "w": 100,
              "guid": "w_cursorExample"
            }
          ]
        }
      ]
    }
  ],
  "datasource": [
    {
      "guid": "dsrc2",
      "query": "table limit=100 araqne_query_logs | fields query_string, _id | search contains(query_string, \"$mytoken$\")",
      "interval": 5,
      "bindings": {
        "mytoken": ""
      }
    },
    {
      "guid": "dsrc3",
      "dependency": "dsrc4"
    },
    {
      "guid": "dsrc4",
      "query": "table duration=10m sys_cpu_logs | eval total = kernel + user | sort _time | limit $mylimit$",
      "interval": 5,
      "bindings": {
        "mylimit": "7"
      }
    },
    {
      "guid": "dsrc5",
      "dependency": "dsrc4",
      "commands": [
        "limit 3",
        "eval hello = \"world\""
      ]
    },
    {
      "guid": "msgsrc1",
      "query": "json \"{\"num\": $from$}\" | repeat count=1000 | eval x=seq() | eval val=rand(100)",
      "interval": 10,
      "bindings": {
        "from": 50
      }
    },
    {
      "guid": "MyTarget",
      "query": "json \"{\"num\": $from$}\" | repeat count=2000",
      "interval": 10,
      "bindings": {
        "from": 11
      }
    },
    {
      'query': 'table window=10s araqne_query_logs | eval val=rand(100)',
      'streaming': true,
      'guid': 'strsrc1'
    }
  ],
  "widgets": [
    {
      "guid": "w_prepareTransactionSuccessTrends",
      "interval": 5,
      "name": "prepareTransactionSuccessTrends",
      "data": {
        "connectNulls": true,
        "percentType": false,
        "labelType": "number",
        "autoSeries": true,
        "spline": false,
        "label": "x",
        "type": "column",
        "excludeSeries": [
          "x"
        ],
        "events": {},
        "source": {
          "guid": "msgsrc1"
        },
        "target": [
          {
            "guid": "MyTarget"
          }
        ]
      },
      "type": "chart"
    },
    // {
    //   "guid": "w_cursorExample",
    //   "interval": 5,
    //   "name": "cursor example",
    //   "data": {
    //     "source": {
    //       "guid": "MyTarget",
    //       "type": "cursor"
    //     }
    //   },
    //   "type": "hello"
    // },
    {
      "data": {
        "default_color": "#eeeeee",
        "default_text": "test",
        "column": "num",
        "rules": [
          {
            "boundary": 50,
            "color": "#2196f3",
            "text": "high",
            "operator": ">"
          },
          {
            "boundary": 50,
            "color": "#f9ce1d",
            "text": "mid",
            "operator": ">"
          },
          {
            "boundary": 50,
            "color": "#00bfa5",
            "text": "low",
            "operator": "<"
          }
        ],
        "type": "field",
        "formatting": "",
        "source": {
          "guid": "MyTarget"
        }
      },
      "name": "ㅋㅋㅋ",
      "guid": "w_alertbox",
      "type": "alertbox"
    },
    {
      "data": {
        "order": ["query_string", "_id"],
        "source": {
          "guid": "strsrc1"
        },
        "type": "field",
        "formatting": ""
      },
      "name": "스트리밍",
      "guid": "w_cursorExample",
      "type": "grid"
    }
  ],
  "version": "2.0.0"
};


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/resources/sample.js